module.exports = __webpack_public_path__ + "img/EARRINGS LIME.90529b1.svg";